import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  imports: [CommonModule],
  selector: 'app-generic-button-with-arrow',
  templateUrl: './genericButtonWithArrow.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./genericButtonWithArrow.scss'],
})
export class GenericButtonWithArrow {
  @Input() label: string = 'Button';
  @Output() onClick = new EventEmitter<any>();
  @Input() minWidth?: string;
  @Input() width?: string;
  @Input() vertical?: boolean;
  @Input() position?: 'left' | 'right';
  @Input() secondary?: boolean;
  @Input() color_string: string = 'blue_button';
  @Input() link?: string;
  @Input() needMoreContrast?: boolean = false;

  constructor(private router: Router) {}

  public handleClick() {
    if (this.link) {
      // Use navigateByUrl to ensure proper history management
      this.router.navigateByUrl(this.link);
    } else {
      this.onClick.emit();
    }
  }
}
